module.exports = __webpack_public_path__ + "static/media/report-empty.771f78bb.png";